import React, { PureComponent, Fragment } from "react";

import ReactEcharts from "echarts-for-react";

export default class Chart extends PureComponent {
  constructor(props) {
    super(props);
    var totalData = this.getTotalData(props.data);
    this.state = {
      unselectedOneList: [],
      unselectedTwoList: [],
      max: totalData.max,
      totalList: totalData.list,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    var totalData = this.getTotalData(nextProps.data);
    this.setState({
      max: totalData.max,
      totalList: totalData.list,
    }, () => {
    });
  };

  getTotalData = (data) => {
    var num = 0;
    var max = 20;
    var result = [];
    if (data && data.newArr) {
      for (var i = 0; i < data.newArr.length; i++) {
        num += data.newArr[i] + data.renewArr[i];
        if (num > max) max = num;
        result.push(num);
      }
    }

    return {
      list: result,
      max: max > 100 ? Math.ceil(max / 100) * 100 + 10 : Math.ceil(max / 10) * 10 + 5,
    };
  };

  containsOneList = (element) => {
    for (var i = 0; i < this.state.unselectedOneList.length; i++) {
      if (this.state.unselectedOneList[i] == element) {
        return i;
      }
    }
    return -1;
  };

  containsTwoList = (element) => {
    for (var i = 0; i < this.state.unselectedTwoList.length; i++) {
      if (this.state.unselectedTwoList[i] == element) {
        return i;
      }
    }
    return -1;
  };

  _onEvent = {
    legendselectchanged: (params, chart, arg1) => {
      var isSelected = params.selected[params.name];

      var stack = "";
      chart._api.getOption().series.forEach((serie) => {
        if (params.name === serie.name) {
          stack = serie.stack;
        }
      });

      var index =
        stack === "one"
          ? this.containsOneList(params.name)
          : this.containsTwoList(params.name);

      if (isSelected) {
        if (index != -1) {
          if (stack === "one") {
            this.state.unselectedOneList.splice(index, 1);
          } else {
            this.state.unselectedTwoList.splice(index, 1);
          }
        }
      } else {
        if (index == -1) {
          if (stack === "one") {
            this.state.unselectedOneList.push(params.name);
          } else {
            this.state.unselectedTwoList.push(params.name);
          }
        }
      }

      chart.setOption({ animation: true });
    },
  };

  render() {
    let series = [
      {
        name: "신규",
        type: "bar",
        stack: "one",
        data: this.props.data ? this.props.data.newArr : [],
        label: {
          show: false,
          position: "insideTop",
          formatter: (param) => {
            if (param.value === 0) {
              return "";
            } else {
              return param.value.toLocaleString();
            }
          },
        },
      },
      {
        name: "재계약",
        type: "bar",
        stack: "one",
        data: this.props.data ? this.props.data.renewArr : [],
        label: {
          show: false,
          position: "top",
          formatter: (param) => {
            let total = 0;
            series.forEach((serie) => {
              if (serie.stack == "one") total += serie.data[param.dataIndex];
            });
            return total;
          },
        },
      },
      {
        name: "신규해지",
        type: "bar",
        stack: "two",
        data: this.props.data ? this.props.data.newTerminateArr : null,
        label: {
          show: false,
          position: "",
          formatter: (param) => {
            if (param.value === 0) {
              return "";
            } else {
              return param.value.toLocaleString();
            }
          },
        },
      },
      {
        name: "재계약해지",
        type: "bar",
        stack: "two",
        data: this.props.data ? this.props.data.renewTerminateArr : [],
        label: {
          show: false,
          position: "top",
          formatter: (param) => {
            let total = 0;
            series.forEach((serie) => {
              if (serie.stack == "two") total += serie.data[param.dataIndex];
            });
            return total;
          },
        },
      },
    //   {
    //     name: "월별 계약 추이",
    //     type: "line",
    //     yAxisIndex: 1,
    //     data: this.state.totalList,
    //   },
    ];
    const legend = ["신규", "재계약", "신규해지", "재계약해지"];
    const titleYAxis = "클래스(건)";
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        formatter: (params, chart, test) => {
          var tooltipHtml = "";

          for(var i = 0; i < params.length; i++) {
            var e = params[i];
            if (!tooltipHtml) tooltipHtml += e.name + "<br/>";

            if (e.seriesName !== "SumOne" && e.seriesName !== "SumTwo") {
              tooltipHtml +=
                e.marker + e.seriesName + " : " + e.value.toLocaleString();

              tooltipHtml += " <br/>";
            }
          }
          return tooltipHtml;
        },
      },
      legend: {
        data: legend,
      },
      xAxis: [
        {
          type: "category",
          data: this.props.data ? this.props.data.dateArr : [],
          axisPointer: {
            type: "shadow",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: titleYAxis,
          min: this.props.data ? this.props.data.min : 0,
          axisLabel: {
            formatter: (param) => {
              return param.toLocaleString();
            },
          },
          axisPointer: {
            label: {
              show: true,
            },
          },
        },
      ],
      series: series,
    };

    return <ReactEcharts theme="macarons" option={option} onEvents={this._onEvent} />;
  }
}
